import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Businessreturns = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Business Tax Returns</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Comprehensive Business Tax Return Services at Easy Tax Experts 
          </h1>
          <p className="tax-section-description">
            Business tax filing is more than just submitting forms—it’s about
            making strategic decisions that protect your company, improve cash
            flow, and minimize tax liability. At{' '}
            <strong>Easy Tax Experts </strong>, our CPAs and EAs provide
            personalized solutions that ensure your returns are accurate,
            compliant, and aligned with your long-term goals.
          </p>

          <h2 className="tax-subheading">
            Why Choose Our Business Tax Return Services?
          </h2>
          <ul className="tax-section-description">
            <li>
              <strong>Industry-Specific Expertise:</strong> From retail and
              technology to professional services and manufacturing, we tailor
              tax strategies to your industry’s challenges.
            </li>
            <li>
              <strong>Proactive Planning:</strong> We don’t just file returns—we
              anticipate issues and create year-round strategies that optimize
              deductions, credits, and compliance.
            </li>
            <li>
              <strong>IRS Representation:</strong> With licensed EAs and CPAs,
              we can represent your business before the IRS during audits,
              appeals, or inquiries.
            </li>
            <li>
              <strong>Peace of Mind:</strong> Stay focused on scaling your
              business while we handle tax laws, deadlines, and filings.
            </li>
          </ul>

          <h2 className="tax-subheading">Our Core Business Tax Services</h2>
          <ol className="tax-section-description">
            <li>
              <strong>Tax Return Preparation:</strong> Accurate filing for all
              business entities:
              <ul>
                <li>Form 1120 – U.S. Corporation Income Tax Return</li>
                <li>Form 1120-S – S Corporation Tax Return</li>
                <li>Form 1065 – Partnership Return</li>
                <li>Form 1120-F – Foreign Corporation Return</li>
              </ul>
            </li>
            <li>
              <strong>Multi-State and Local Compliance:</strong> Assistance with
              filing requirements across different states and municipalities.
            </li>
            <li>
              <strong>Tax Planning & Strategy:</strong> Ongoing analysis to
              reduce liabilities, optimize deductions, and manage quarterly
              estimated payments.
            </li>
            <li>
              <strong>Entity Structure Review:</strong> Evaluating whether your
              current setup (LLC, S-Corp, C-Corp, Partnership) is still the most
              tax-efficient.
            </li>
            <li>
              <strong>International Tax Filing:</strong> Guidance on reporting
              foreign income, foreign-owned U.S. businesses, and cross-border
              tax treaties.
            </li>
            <li>
              <strong>Audit Representation & Support:</strong> End-to-end
              support if the IRS questions or audits your filings.
            </li>
            <li>
              <strong>Amended Returns:</strong> Correction of prior filings to
              fix errors, claim missed deductions, or avoid penalties.
            </li>
            <li>
              <strong>Technology-Driven Filing:</strong> Secure digital
              processes to collect data, track filings, and deliver faster,
              paperless returns.
            </li>
          </ol>

          <h2 className="tax-subheading">Partner with Us for Success</h2>
          <p className="tax-section-description">
            At <strong>Easy Tax Experts </strong>, we believe filing your tax
            returns should create opportunities, not stress. With our expert
            team, advanced tools, and client-first approach, we’ll help you
            reduce risk, maximize efficiency, and stay ahead of changing tax
            laws. <br />
            <br />
            <strong>Ready to file smarter?</strong> Contact us today and let’s
            build a tax strategy that grows with your business.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Businessreturns;
